import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Accenture from '../../img/Agenda/Accenture.png'
import daily from '../../img/Agenda/daily.png'
import Hush from '../../img/Agenda/Hush.png'
import Leardini from '../../img/Agenda/Leardini.png'
import Salnikov from '../../img/Agenda/Salnikov.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:10',
                    photo: Hush,
                    name: 'James Hush',
                    position: 'Solutions Engineer',
                    ln: 'https://www.linkedin.com/in/jameshush/',
                    website: 'https://www.jameshush.com/',
                    github: 'https://github.com/daily-co',
                    logo: daily,
                    title: 'Intro to WebRTC with DailyJS',
                    abstract: `Since the pandemic hit video conferencing has exploded in popularity. Even live events have transformed with many (including this one!) going virtual too. Creating live video experiences used to be impossible for a single developer. Until now.

                    Join James Hush as he walks us through coding a WebRTC video call with DailyJS and vanilla JavaScript. He'll be putting the FUN in FUNdamentals, so no prior coding experience required!`,
                },
                {
                    time: '09:40',
                    photo: Leardini,
                    name: 'Francesco Leardini',
                    position: 'Principal Consultant and Trainer',
                    ln: 'https://www.linkedin.com/in/leardini81/',
                    tw: 'https://twitter.com/paco_ITA',
                    github: 'https://github.com/pacoita',
                    logo: Accenture,
                    title: 'Wait...can my browser do that?',
                    abstract: `We have new powerful instruments to leverage current web apps and provide a richer experience to our users. With the aim of modern web APIs, it is possible to design completely new functionalities and explore unique technological combinations, changing the way we develop and interact with web apps. We can directly use hardware devices and just through our browser! Let's explore some of the most exciting APIs and see how we can combine them to unlock new scenarios and give superpowers to our web apps.`,
                },
                {
                    time: '10:10',
                    photo: Salnikov,
                    name: 'Maxim Salnikov',
                    position: 'Senior Developer Engagement Lead at Microsoft',
                    ln: 'https://www.linkedin.com/in/webmax/',
                    tw: 'https://twitter.com/webmaxru',
                    title: 'Native Web Apps: Are We There Yet?',
                    abstract: `There are so many discussions about web VS native apps. Will we get to the point where the Web becomes truly Native for the majority of the platforms? Progressive Web Apps, Project Fugu, WebAssembly & other technologies actively contribute to moving in this direction. In this session, we go through a list of details that make the integration of an application & operating system seamless, and map it to the APIs available for the web platform. With the knowledge of what's available today and what's coming soon, you are empowered to build truly Native Web Apps to deliver the best user experience!`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">September 27 09:00 - 21:20</p>
                    <p className="agenda_day">Junior Track</p>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/js092022' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};